import { loan_application_api } from '@axo/shared/data-access/api';
import { loan_application } from '@axo/shared/data-access/types';
import { Handler } from '../api-orchestrator';
import { IPreconditions } from '../types/IPreconditions';

interface IDependencies {
  postDebt: typeof loan_application_api.postDebt;
  patchDebt: typeof loan_application_api.patchDebt;
  deleteDebt: typeof loan_application_api.deleteDebt;
}

export const debtHandlerFactory =
  ({
    postDebt,
    patchDebt,
    deleteDebt,
  }: IDependencies): Handler<loan_application.Debt, IPreconditions> =>
  async ({
    data,
    preconditions: { customerId, customerJWT, loanApplicationId, ids },
    baseUrl,
    frontendId,
  }) => {
    if (!customerId || !customerJWT || !loanApplicationId) {
      return { didSync: false };
    }

    const id = ids.debts?.[frontendId];
    const api = { url: { service: baseUrl }, token: customerJWT };

    if (id) {
      if (data.Type === null) {
        await deleteDebt(api)(loanApplicationId, id);

        delete ids.debts?.[frontendId];

        return {
          didSync: true,
          newPreconditions: {
            ids,
          },
        };
      }

      await patchDebt(api)(loanApplicationId, id, data);
      return {
        didSync: true,
      };
    }

    if (data.Type === null || data.Type === ('null' as any)) {
      console.error(
        'Error: trying to create a debt with null type: ',
        data.Type
      );

      return {
        didSync: false,
      };
    }

    const debt = await postDebt(api)(loanApplicationId, data);

    return {
      didSync: true,
      newPreconditions: {
        ids: {
          ...ids,
          debts: {
            ...ids.debts,
            [frontendId]: debt.ID,
          },
        },
      },
    };
  };
